
import { Component, Vue } from "vue-property-decorator";
import { roleService } from "@/api/settings/role";
import FormBase from "@/lib/view-base/formbase";
import { CreateRoleDto, FlatPermissionDto } from "@/api/service-proxies";
import { TreeData } from "element-ui/types/tree";
import { Tree } from "element-ui";

@Component({
  name: "CreateRole",
  components: {}
})
export default class CreateRole extends FormBase {
  role: CreateRoleDto = new CreateRoleDto();
  permissions?: FlatPermissionDto[] | null = null;

  rules: object = {
    name: [
      { required: true, message: "请输入角色名称", trigger: "blur" },
      { max: 16, message: "角色名称最大长度为16", trigger: "blur" }
    ],
    displayName: [
      { required: true, message: "请输入显示名称", trigger: "blur" },
      { max: 16, message: "显示名称最大长度为16", trigger: "blur" }
    ],
    description: [
      { max: 128, message: "Description最大长度为128", trigger: "blur" }
    ]
  };

  mounted() {
    this.getPermissions();
  }

  get computedPermission() {
    let data: TreeData[] = [];
    this.buildPermissionTree(null, data);

    return data;
  }

  buildPermissionTree(parentName: string | null, data: TreeData[]) {
    let permissions = this.permissions.filter(p => p.parentName == parentName);

    permissions.forEach(permission => {
      let node = {
        id: permission.name,
        label: permission.displayName,
        children: []
      };

      this.buildPermissionTree(permission.name, node.children);
      data.push(node);
    });
  }

  async getPermissions() {
    var result = await roleService.getAllPermissions();
    this.permissions = result.items;
  }

  async submitExecute(): Promise<void> {
    let permissions = (this.$refs.permissionTree as Tree)
      .getCheckedNodes(false, true)
      .map(item => item.id);
    this.role.permissions = permissions;

    await roleService.create(this.role);
  }
}
